export default "__VITE_ASSET__CH5ZBbM5__"